import { DataSourceType } from "../dtos/DataSourceType";

// function getType(item: DataSource) {
//   const type = DataSourceTypes.find((t) => t.value === item.type);
//   return type!;
// }

function isDatabaseSource(type: DataSourceType) {
  const types: DataSourceType[] = ["server", "database", "postgres", "mysql", "mssql"];
  return types.includes(type);
}

function canTest(type: DataSourceType) {
  const types: DataSourceType[] = ["database", "server", "postgres", "mysql", "mssql", "googleSheets", "api", "website", "notion", "snowflake", "hubspot"];
  return types.includes(type);
}

function getDefaultConfig(dataSourceType: DataSourceType | undefined | string) {
  if (!dataSourceType) {
    return {};
  }
  switch (dataSourceType as DataSourceType) {
    default:
      return {};
  }
}

export default {
  isDatabaseSource,
  canTest,
  getDefaultConfig,
};
